<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商品名称">
                <a-input v-model="queryParam.goodsName" placeholder="请输入商品名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="SKU名称">
                <a-input v-model="queryParam.skuName" placeholder="请输入SKU名称" allow-clear />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.purchaseRequestForm.handleAdd()" v-hasPermi="['retail:purchase:create']">
          <a-icon type="shopping-cart" />发起要货
        </a-button>
      </div>

      <!-- 要货申请表单 -->
      <purchase-request-form ref="purchaseRequestForm" @ok="getList" />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :bordered="tableBordered"
        @change="handleTableChange"
      >
        <span slot="goodsName" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="skuName" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="availableStock" slot-scope="text">
          <a-tag :color="text > 0 ? 'green' : 'red'">{{ text }}</a-tag>
        </span>
        <span slot="shopPrice" slot-scope="text">
          ¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}
        </span>
        <span slot="salePrice" slot-scope="text">
          ¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}
        </span>
        <span slot="alarmFlag" slot-scope="text">
          <a-tag :color="text === 1 ? 'red' : 'green'">{{ text === 1 ? '预警' : '正常' }}</a-tag>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getStoreInventoryList } from '@/api/retail/inventory'
import PurchaseRequestForm from './modules/PurchaseRequestForm'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

export default {
  name: 'StoreInventory',
  components: {
    PurchaseRequestForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      queryParam: {
        goodsName: undefined,
        skuName: undefined,
        alarmFlag: undefined
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '30', '50', '100']
      },
      columns: [
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'goodsName' },
          align: 'center'
        },
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'skuName' },
          align: 'center'
        },
        {
          title: '门店拿货价(元)',
          dataIndex: 'shopPrice',
          width: 130,
          scopedSlots: { customRender: 'shopPrice' },
          align: 'center'
        },
        {
          title: '门店销售价(元)',
          dataIndex: 'salePrice',
          width: 130,
          scopedSlots: { customRender: 'salePrice' },
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 180,
          align: 'center'
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    moment,
    parseTime(time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    getList() {
      this.loading = true
      const params = {
        ...this.queryParam,
        current: this.pagination.current,
        size: this.pagination.pageSize
      }
      getStoreInventoryList(params).then(response => {
        if (response.data && response.data.records) {
          this.list = response.data.records || []
          this.pagination.total = response.data.total || 0
        } else if (Array.isArray(response.data)) {
          this.list = response.data
          this.pagination.total = response.data.length
        } else {
          this.list = []
          this.pagination.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.pagination.current = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        goodsName: undefined,
        skuName: undefined,
        alarmFlag: undefined
      }
      this.pagination.current = 1
      this.getList()
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.getList()
    }
  }
}
</script>
